<template>
  <span class="source">
    <i :class="`icon_source ${source}`"></i>
    数据来源：{{
      isCer ? "实名认证" : source === "CONSUMER" ? "本人自填" : dataSourceName
    }}
    <!-- 数据来源：{{
      source === "CONSUMER" ? "本人自填" : dataSourceName
    }} -->

    <!-- {{
  data.dataSourceType==='CONSUMER'
  ?
  (data.modifiable===false?'实名认证':data.dataSourceName + (data.dataSourceType==='CONSUMER'?'自填':'添加'))
  :
  data.dataSourceName + (data.dataSourceType==='CONSUMER'?'自填':'添加')}} -->
  </span>
</template>

<script>
export default {
  props: {
    source: {
      type: String
    },
    dataSourceName: {
      type: String
    },
    isCer: {
      type: Boolean,
      default: false
    }
  } //["source", "dataSourceName","isCer"]
};
</script>

<style scoped lang="scss">
.source {
  color: #6e6e6e;
  font-size: 12px;
  .icon_source {
    display: inline-block;
    margin-left: 6px;
    margin-right: 9px;
  }
  // 来源于国家公信力权威部门
  // .country {
  //   width: 15px;
  //   height: 17px;
  // }
  // 来源于本人自填
  .CONSUMER {
    width: 15px;
    height: 15px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/CONSUMER.png")
      no-repeat;
    background-size: cover !important;
  }
  // 来源于学校/企业/社会机构
  .BUSINESS {
    width: 17px;
    height: 17px;
    background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/BUSINESS.png")
      no-repeat;
    background-size: cover !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Source.vue